import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as _ from 'lodash';
declare var $:any;

@Component({
	selector: 'app-template',
	templateUrl: './template.component.html',
	styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
	filter = {};
	limit; skip = 0;
	data_tpl;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		this.loadTpl();
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}
	goTab(el) {
		$(`a[href="${el}"]`)[0].click();
	}

	loadTpl(param = null, add = false) {
		if(param) {
			this.filter = $.extend(this.filter, param);
			let paramIndex = Object.keys(this.filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(this.filter)[paramIndex])){
				delete this.filter[Object.keys(param)[0]];
			}
		}
		Object.assign(this.filter, {"deleted":false, 'codeorg': this.appServices.appname})
		this.appServices.api('Hosreports/find', {
			'filter': this.limit ? `{"where":${JSON.stringify(this.filter)},"limit":${this.limit},"skip":${this.skip},"order":"created_dt desc"}` : `{"where":${JSON.stringify(this.filter)},"skip":${this.skip},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_tpl.res = obj.component.data_tpl.res.concat(json.res);
			} else {
				obj.component.data_tpl = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doMore() {
		this.limit = Math.floor(this.data_tpl.total / this.data_tpl.page);
		this.skip = this.data_tpl.res.length;
		this.loadTpl(this.filter, true);
	}
	saveTpl(data) {
		data['codeorg'] = this.appServices.appname;
		data = _.pickBy(data);
		data['deleted'] = false;
		this.appServices.api('Hosreports/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.loadTpl();
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/template/template.component.ts